// VH-283: the one password rule, the same as the backend's PASSWORD_MIN /
// PASSWORD_MAX (app/schemas/auth.py) and as FinanceHub and HubPlatform.
// Applies where a password is SET; the login checks no length.
export const PASSWORD_MIN = 12
export const PASSWORD_MAX = 200

export const passwordFits = (value) =>
  typeof value === 'string' && value.length >= PASSWORD_MIN && value.length <= PASSWORD_MAX
